<template>
  <div>
    <navigation-top/>
    <div class="subscription-container">
      <div class="pt-5 pb-5">
        <v-alert type="info" variant="tonal" color="var(--blue-3)" class="pa-2"
                 v-if="
                   !isEnterpriseUser &&
                     isSubscriptionAdmin &&
                     subscriptionAccessType === 'FULL' &&
                     !loadingActiveSubscription && activeSubscription && !loadingSubscriptionUsers && subscriptionUsers &&
                     activeSubscription.subscriptionDetails.quantity > subscriptionUsers.length &&
                     subscriptionUsers.length !== activeSubscription?.scheduleSubscriptionDetails?.phases?.[0]?.items?.[0]?.quantity &&
                     (!activeSubscription.subscriptionDetails.cancelAt || !!activeSubscription.subscriptionDetails.cancelAt && !!activeSubscription.scheduleSubscriptionDetails)
                 ">
          <div class="d-flex ga-4 align-center justify-space-between">
            <span>
              You're currently paying for {{
                activeSubscription.subscriptionDetails.quantity
              }} seats but only using {{
                subscriptionUsers.length
              }}. You can either add {{ activeSubscription.subscriptionDetails.quantity - subscriptionUsers.length }} more users or remove the extra seats to save money.
            </span>

            <v-btn
              variant='tonal'
              density="compact"
              :loading="loadingDowngradeSubscriptionQuantity"
              @click="downgradeSubscriptionQuantity"
            >
              Remove seats
            </v-btn>
          </div>
        </v-alert>
        <v-alert type="info" variant="tonal" color="var(--blue-3)" class="pa-2"
                 v-if="!!scheduledSubscriptionQuantity &&
                   scheduledSubscriptionQuantity !== activeSubscription?.subscriptionDetails?.quantity">
          You are scheduled to pay for {{ scheduledSubscriptionQuantity }} seats on the next billing cycle.
        </v-alert>
      </div>
      <div class="card subscription-card">
        <div class="subscription-card-menu">
          <div class="subscription-menu h-100">
            <RouterLink to="/subscription/my-plan" active-class="active" class="subscription-menu-item">
              <v-icon color="primary">mdi-calendar-check</v-icon>
              <span class="subscription-menu-item-label">My Plan</span>
            </RouterLink>
            <RouterLink to="/subscription/billing" active-class="active" class="subscription-menu-item"
                        v-if="isSubscriptionAdmin && !isEnterpriseUser">
              <v-icon color="primary">mdi-text-box-outline</v-icon>
              <span class="subscription-menu-item-label">Billing</span>
            </RouterLink>
            <RouterLink to="/subscription/manage-users" active-class="active" class="subscription-menu-item"
                        v-if="isSubscriptionAdmin">
              <v-icon color="primary">mdi-account-multiple-outline</v-icon>
              <span class="subscription-menu-item-label">Manage users</span>
            </RouterLink>
            <div class="d-flex align-center justify-center w-100">
              <v-progress-circular
                indeterminate
                color="white"
                size="16"
                width="2"
                v-if="loadingActiveSubscription"
              >
              </v-progress-circular>
            </div>
          </div>
        </div>
        <div class="subscription-card-body">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import NavigationTop from '../components/NavigationTop.vue'
import { mapState } from 'vuex'

export default {
  components: {
    NavigationTop
  },
  computed: {
    ...mapState({
      plan: state => state.payments.plan,
      subscriptionType: state => state.payments.subscriptionType,
      users: state => state.payments.users,
      orderCalculationText: state => state.payments.orderCalculationText,
      totalPrice: state => state.payments.totalPrice,
      currentUser: state => state.user.user,
      activeSubscription: state => state.payments.activeSubscription,
      loadingActiveSubscription: state => state.payments.loadingActiveSubscription,
      loadingSubscriptionUsers: state => state.payments.loadingSubscriptionUsers,
      subscriptionUsers: state => state.payments.subscriptionUsers,
      loadingDowngradeSubscriptionQuantity: state => state.payments.loadingDowngradeSubscriptionQuantity,
      subscriptionAccessType: state => state.payments.subscriptionAccessType,
      isEnterpriseUser: state => state.payments.isEnterpriseUser,
      isSubscriptionAdmin: state => state.payments.isSubscriptionAdmin
    }),
    scheduledSubscriptionQuantity () {
      return this.activeSubscription?.scheduleSubscriptionDetails?.phases?.[0]?.items?.[0]?.quantity
    }
  },
  methods: {
    async downgradeSubscriptionQuantity () {
      const response = await store.dispatch('payments/downgradeSubscriptionQuantity')
      if (response.success) {
        this.$store.commit('snackbar/showMessage', { content: 'Your seat count has been updated.' }, { root: true })
      }
    }
  },
  mounted () {
    if (this.currentUser) {
      store.dispatch('payments/getPayerUserSubscription')
    }
  },
  watch: {
    currentUser: function (currentUser) {
      if (currentUser) {
        store.dispatch('payments/getPayerUserSubscription')
      }
    }
  }
}
</script>

<style scoped>
.subscription-container {
  max-width: 996px;
  margin: 0 auto;
}

.subscription-card {
  display: flex;
  margin: 0 auto 32px;
  height: 700px;
  padding: 32px 24px !important;
}

.subscription-card-menu {
  padding-right: 16px;
  border-right: 1px solid var(--light-3);
}

.subscription-card-body {
  width: 100%;
  height: 100%;
  padding-left: 16px;
}

.subscription-menu {
  gap: 8px;
  width: 137px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.subscription-menu-item {
  gap: 8px;
  display: flex;
  padding: 8px;
  border-radius: 42px;
  align-items: center;
  text-decoration: none;

  &.active {
    background: var(--light-2, #F5F2F0);
  }
}

.subscription-menu-item-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--dark-4, #363A40);
}
</style>
